import EventBus from '../../../utils/event-bus'
import ExportModal from './ExportModal'
import GroupAction from './GroupAction'
import ModalOpener from '../../modal/Opener'
import SavedFilterOpener from '../../saved-filter/SavedFilterOpener.vue'
import ListOrder from '../../templated-list/components/hamburger/ListOrder.vue'
import Limitation from '../../templated-list/components/hamburger/Limitation'
import { createStorage } from '../../../utils'
import { cloneDeep, get, isEmpty, map, isString } from 'lodash'
import {
  DEFAULT_LIMITATION,
  DEFAULT_LIST_VISIBILITY_OPTIONS,
  DEFAULT_ORDER,
  DEFAULT_PAGER,
  INTERVAL_COLUMN_TYPES,
  LIST_VIEW_MODES,
  SELECTED_ROW_OPTIONS,
  VIEW_MODE_CARD,
  VIEW_MODE_DETAIL,
  VIEW_MODE_GRID,
} from '../lib/list-constants'

import bindValuesMixin from '../../raw-sql/mixin-bind-values'
import localStore from '../../../utils/mixin-local-store'
import pagination from '../../../utils/mixin-pagination'
import { PANEL_TYPES } from '../../layout-manager/gui-editor/options/schema'

export default {
  mixins: [bindValuesMixin, localStore, pagination],
  components: {
    ExportModal,
    GroupAction,
    ModalOpener,
    SavedFilterOpener,
    ListOrder,
    Limitation,
  },
  data() {
    return {
      SELECTED_ROW_OPTIONS,
      isGroupActionsOpen: false,
    }
  },
  computed: {
    activeAggregations() {
      return this.aggregations.reduce((accumulator, { column, aggr }) => {
        if (aggr !== 'Off') {
          accumulator.push({ column, aggr })
        }
        return accumulator
      }, [])
    },
    aggregations: {
      get() {
        return this.$get('aggregations')
      },
      set(aggregations) {
        this.$dispatch('setAggregations', { aggregations })
      },
    },
    areGroupActionsAvailable() {
      return this.$get('areGroupActionsAvailable')
    },
    availableColumns() {
      return this.$get('availableColumns')
    },
    availableInList() {
      return this.$get('availableInList')
    },
    buttons() {
      return this.$get('buttons')
    },
    collectionOrId() {
      return this.$get('collectionOrId')
    },
    columns() {
      return this.$get('columns')
    },
    currentParameters() {
      return this.$get('currentParameters')
    },
    currentView() {
      return get(LIST_VIEW_MODES, this.viewMode)
    },
    defaultShowInList() {
      return this.$get('defaultShowInList')
    },
    exportOriginalType() {
      return get(this.extendedOptions, 'exportOriginalType', false)
    },
    extendedOptions() {
      return this.$get('extendedOptions')
    },
    exportSettings() {
      return this.$get('exportSettings')
    },
    hamburgerSettings() {
      return this.$get('hamburgerSettings')
    },
    id() {
      return this.$get('id')
    },
    isHamburgerVisible() {
      return this.$get('isHamburgerVisible')
    },
    isQueueButtonGroupVisible() {
      return get(this.$CORE, 'env.importerEnabled') && !this.isSqlChosen && this.showQueueProgressButton
    },
    isExportAvailable() {
      return this.$get('isExportAvailable')
    },
    isSqlChosen() {
      return this.$get('isSqlChosen')
    },
    isTemplatedListControl() {
      return this.$get('componentType') === PANEL_TYPES.TEMPLATED_LIST
    },
    modalIdSave() {
      return `list-modal-save-${this.collectionOrId}`
    },
    modalIdShowColumns() {
      return `show-columns-modal-${this.collectionOrId}-${this.panelId}`
    },
    mongoId() {
      return this.$get('mongoId')
    },
    orderParams() {
      if (isEmpty(this.$get('orderState'))) return []
      return map(this.$get('orderState'), (value, key) => {
        return { column: key, dir: value }
      })
    },
    panelId() {
      return this.$get('panelId')
    },
    processActions() {
      return this.$get('processActions')
    },
    rawSqlNamespace() {
      return this.$get('rawSqlNamespace')
    },
    runGroupActionsOnAllWithoutSelect() {
      return this.$get('runGroupActionsOnAllWithoutSelect')
    },
    selectedRows() {
      return this.$get('selectedRows')
    },
    selectedRowsFilter: {
      get() {
        return this.$get('selectedRowsFilter')
      },
      set(selectedRowsFilter) {
        //@TODO osszehangolni watchosra a listakat
        this.$dispatch('setSelectedRowsFilter', { selectedRowsFilter })
        EventBus.$emit(`apply-filter-${this.id}`, { id: this.id, type: 'button' })
      },
    },
    selectedRowsFilterIcon() {
      return SELECTED_ROW_OPTIONS[this.selectedRowsFilter].icon
    },
    showActionButtons() {
      return this.$get('showActionButtons')
    },
    showColumnSelector() {
      return this.$get('showColumnSelector')
    },
    showExportButton() {
      return this.$get('showExportButton')
    },
    showListOrder() {
      return this.$get('showListOrder')
    },
    showPageLimiter() {
      return this.$get('showPageLimiter')
    },
    showQueueActionsButton() {
      return this.visibilityState({ key: 'showQueueActionsButton' })
    },
    showQueueProgressButton() {
      return (
        this.visibilityState({ key: 'showQueueActionsButton' }) || this.visibilityState({ key: 'showImportButtons' })
      )
    },
    showResetButton() {
      return this.$get('showResetButton')
    },
    showSavedFilter() {
      return this.$get('showSavedFilter')
    },
    showRowSelectionOption() {
      return this.$get('showRowSelectionOption')
    },
    sort() {
      return this.$get('sort')
    },
    storageKey() {
      return this.$get('storageKey')
    },
    viewMode: {
      get() {
        return this.$get('viewMode')
      },
      set(mode) {
        this.setViewMode(mode)
      },
    },
    views() {
      return this.$get('views')
    },
    visibilityState() {
      return this.$get('visibilityState')
    },
    uniqueId() {
      return this.panelId && isString(this.panelId) ? get(this.panelId.match(/\d+$/), '0', 0) : this.mongoId
    },
  },
  methods: {
    changeView(mode) {
      if (this.viewMode !== mode) {
        this.viewMode = mode
      }
    },
    handleCommand(command) {
      if (!command) return
      const { payload, type } = command
      switch (type) {
        case 'view': {
          this.changeView(payload)
          break
        }
        case 'rowFilter': {
          this.selectedRowsFilter = payload
          this.handleRowFilterChange(payload)
          break
        }
        case 'action': {
          this.$dispatch('setSelectedGroupAction', {
            processId: payload.processId,
          })
          this.isGroupActionsOpen = true
          break
        }
        default:
          return
      }
    },
    handleRowFilterChange() {
      EventBus.$emit(`apply-filter-${this.id}`, { id: this.id, type: 'button' })
    },
    isInterval(type) {
      return [
        INTERVAL_COLUMN_TYPES.DATE_INT_FORMAT,
        INTERVAL_COLUMN_TYPES.TIME_INT_FORMAT,
        INTERVAL_COLUMN_TYPES.DATETIME_INT_FORMAT,
        INTERVAL_COLUMN_TYPES.NUMBER_INT_FORMAT,
      ].includes(type)
    },
    resetParams() {
      if (this.isTemplatedListControl) {
        this.$dispatch('clearFilter')
        this.$dispatch('setSearchTrigger', { searchTrigger: 'clear-button' })
      } else {
        this.$dispatch('setSelectedRowsFilter', { selectedRowsFilter: 'normal' })
        this.$dispatch('setSearchParams', { params: {} })
        this.$dispatch('setUniversalFilter', { value: '' })
        this.$dispatch('setOrder', { value: cloneDeep(DEFAULT_ORDER) })
        this.$dispatch('setPager', { value: { ...cloneDeep(DEFAULT_PAGER), total: get(this.pager, 'total', 0) } })
        this.$dispatch('setShowInList', { showInList: this.defaultShowInList })
        this.$dispatch('setAggregations', { aggregations: [] })
        this.deleteFilterParam()
        this.localStore.setStoreContent({})
        if (this.rawSqlNamespace) {
          this.resetBindValues()
          this.$dispatch(`setConditions`, { conditions: [] }, this.rawSqlNamespace)
        }
        EventBus.$emit(`reset-order-${this.id}`, { id: this.id })
      }
    },
    deleteFilterParam() {
      const searchParams = new URLSearchParams(window.location.search)
      searchParams.delete(`filter-${this.uniqueId}`)
      const newUrl = `${window.location.protocol}//${window.location.host}${
        window.location.pathname
      }?${searchParams.toString()}`
      window.history.pushState({ path: newUrl }, '', newUrl)
    },
    setSelectedRowsFilter(filter) {
      this.selectedRowsFilter = filter
    },
    setViewMode(mode) {
      const visibilityOptions = cloneDeep(this.$get('listVisibilityOptions'))
      const gridOptions = Object.assign({}, visibilityOptions, DEFAULT_LIST_VISIBILITY_OPTIONS)
      const cardOrDetailOptions = Object.assign({}, visibilityOptions, {
        visibleUnselectedRows: true,
        showActionButtons: true,
      })
      switch (mode) {
        case VIEW_MODE_CARD: {
          this.$dispatch('setListVisibilityOptions', {
            options: cardOrDetailOptions,
          })
          this.limit = this.pageSize || DEFAULT_LIMITATION
          break
        }
        case VIEW_MODE_DETAIL: {
          this.$dispatch('setListVisibilityOptions', {
            options: cardOrDetailOptions,
          })
          this.limit = this.pageSize || DEFAULT_LIMITATION
          break
        }
        case VIEW_MODE_GRID: {
          this.$dispatch('setListVisibilityOptions', { options: gridOptions })
          break
        }
      }
      this.$dispatch('setViewMode', { mode })
      this.localStore.setItemValue('viewMode', mode)
    },
    toggleGroupActionModal(isOpen) {
      this.isGroupActionsOpen = isOpen
    },
  },
  created() {
    this.localStore = createStorage(this.storageKey)
  },
}
